<template>
  <ls-search-form :formList="formList" @search="onSearch" @reset="resetQuery" ref="searchForm">
    <global-select
      key="supplierCode"
      slot="supplierCode"
      v-decorator="['supplierCode']"
      :value.sync="queryParams.supplierCode"
      selectType="selectSearch"
      requestApi="/mdm/mdmOrgSupplier/supplierNameList"
      :selectItem="{ value: 'label', label: 'realValue' }"
      searchParam="supplierName"
    />
    <global-select
      selectType="selectSearch"
      v-decorator="['projectDept']"
      :value.sync="queryParams.projectDept"
      slot="projectDept"
      key="projectDept"
      :dropdown-match-select-width="false"
      requestApi="/system/lookup/data/likeList"
      :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
      :setParams="{ lookupType: 'SCP_PROJECT_TEAM' }"
      searchParam="lookupValue"
    />
    <global-select
      slot="itemCode"
      v-decorator="['itemCode']"
      selectType="selectAssembleSearch"
      :focusGet="true"
      requestApi="/mes/mesDiscreteJobs/assemblyBox"
      :selectItem="{
        value: 'selectedValue', label: 'bringOutDataOne'
      }"
      searchParam="itemCode"
      :setParams="{ organizationCode: 'A001' }"
      :dropdown-match-select-width="false"
      :indexInKey="true"
    />
    <a-radio-group slot="dataDimension" v-model="queryParams.dataDimension">
      <a-radio value="01" >数量</a-radio>
      <a-radio value="02" >金额</a-radio>
    </a-radio-group>
    <a-date-picker
      class="year-picker-css"
      slot="year"
      mode="year"
      :allowClear="false"
      format="YYYY"
      :open="isOpen"
      :value="queryParams.year"
      @openChange="onOpenChange"
      @panelChange="panelChange"
    />
  </ls-search-form>
</template>

<script>
export default {
  name: 'PlanPoolSearchForm',
  data () {
    return {
      isOpen: false, // 控制年份浮窗显示和关闭
      formList: [
        { label: "供应商", type: "supplierCode", decorator: ['supplierCode'] },
        { label: "项目部", type: "projectDept", decorator: ['projectDept'] },
        { label: "物料编码", type: "itemCode", decorator: ['itemCode'] },
        { label: "物料名称", type: "input", decorator: ['itemName'], attrs: { placeholder: "请输入" } },
        { label: "系列主型号", type: "input", decorator: ['seriesModel'], attrs: { placeholder: "请输入" } },
        { label: "数据维度", type: "dataDimension", decorator: ['dataDimension'] },
        { label: "年份", type: "year", decorator: ['year'] },
        { label: "计划专员", type: "input", decorator: ['planUser'], attrs: { placeholder: "请输入" } }
      ],
      // 查询参数
      queryParams: {
        supplierCode: undefined,
        projectDept: undefined,
        itemCode: undefined,
        dataDimension: '01',
        year: this.$moment(new Date()).format('YYYY')
      }
    }
  },
  methods: {
    onSearch(val) {
      this.$emit('search', { ...this.queryParams, ...val })
    },
    // 年份选择后回调
    panelChange(value) {
      this.queryParams.year = value ? this.$moment(value).format('YYYY') : '';
      this.isOpen = false;
    },
    // 控制年份浮窗显示和关闭
    onOpenChange(val) {
      this.isOpen = !!val
    },
    // 重置按钮操作
    resetQuery () {
      this.queryParams = {
        dataDimension: '01',
        billCode: undefined,
        billCode2: undefined,
        year: this.$moment(new Date()).format('YYYY')
      }
      this.$refs.searchForm.form.setFieldsValue(this.queryParams)
      this.$emit('search', this.queryParams)
    }
  },
  mounted () {
    this.$emit('search', this.queryParams)
  }
}
</script>

<style lang="less" scoped>
.year-picker-css{
  width: 100%;
}
</style>
